import { z } from 'zod'
import { baseSchema } from '../common/schema'

export const roleSchema = baseSchema.extend({
    roleId: z.string(),
    roleName: z.string(),
    roleDescription: z.string(),
})
